/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMagnifyingGlassTriangleDown: {
  name: 'magnifying-glass-triangle-down';
  data: string;
} = {
  name: 'magnifying-glass-triangle-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 5a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l3.387 3.387a1 1 0 0 1-1.414 1.414l-3.387-3.387A8 8 0 0 1 3 11Zm10.019-1H8.98c-1.124-.012-1.24 1-.563 1.659l1.801 1.998c.274.334.756.342.78.342h.002c.024 0 .506-.008.78-.342l1.8-1.998c.678-.659.562-1.671-.562-1.659Z" fill="currentColor"/></svg>`,
};
